module.exports = __webpack_public_path__ + "img/analiticom.a51a4166.jpg";